import React from 'react'
import type { FC } from 'react'
import { Button, Typography } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { useHistory } from 'react-router'
import { SNACKBAR_VARIANTS } from 'redesign/components/atoms/snackbar-base/constants'
import Dialog from 'redesign/components/molecules/dialog'
import routes from 'services/RoutesProvider/routes'
import Toast from '../toast'
import type { WrongPinWarningProps } from './types'

const WrongPinWarning: FC<WrongPinWarningProps> = ({ pinState, closeSnackbar }) => {
  const { t } = useFavurTranslation()
  const history = useHistory()

  return (
    <>
      <Toast
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={Boolean(pinState.pinInvalid && pinState.attemptsLeft)}
        onClose={closeSnackbar}
        variant={SNACKBAR_VARIANTS.error}
        title={t('component.pinLogin.flash.title')}
        description={t('component.pinLogin.flash.text', { attemptsLeft: pinState.attemptsLeft })}
        data-testid="wrong-pin-warning-message"
      />
      <Dialog
        open={pinState.pinBlocked}
        title={t('component.pinLogin.dialog.title')}
        actions={
          <>
            <Button
              onClick={() => history.push(routes.pinReset, { from: { pathname: history.location.pathname } })}
              color="primary"
              data-testid="pin-reset"
            >
              {t('component.pinLogin.dialog.goToSettings')}
            </Button>
            <Button
              onClick={() => history.push(routes.dashboard, { from: { pathname: history.location.pathname } })}
              color="secondary"
              data-testid="close-dialog"
            >
              {t('common.close')}
            </Button>
          </>
        }
      >
        <Typography variant="body2">{t('component.pinLogin.dialog.text')}</Typography>
      </Dialog>
    </>
  )
}

export default WrongPinWarning
